import React, { useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Row, Col, Card, Modal, Button, Alert, Form } from 'react-bootstrap';
import { VerticalForm } from '../../components';
import { FileUpload, SelectInput } from '../../components/FormComponents';
import PageTitle from '../../components/PageTitle'
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import FeatherIcon from 'feather-icons-react';
import Popup from '../../components/Popup';
import { uploadExcelFile } from '../../utils/Service';
import UploadExcel from '../../components/UploadExcel';
import FileUploader from '../../components/FileUploader';

const API = process.env.REACT_APP_CLIENT_IP;

function WifiToken() {
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [inputData, setInputData] = useState({})
    const [notify, setNotify] = useState({ show: false, variant: '', message: '' })
    const [showPop, setShowPop] = useState({ show: false, dataId: '' });


    const sizePerPageList = [
        {
            text: '5',
            value: 5,
        },
        {
            text: '10',
            value: 10,
        },
        {
            text: '25',
            value: 25,
        },
        {
            text: 'All',
            value: data.length,
        },
    ];

    const columns = [
        {
            Header: 'Package',
            accessor: 'productName',
            sort: true,
        },
        {
            Header: 'Voucher Name',
            accessor: 'voucherName',
            sort: false,
        },
        {
            Header: 'Is Taken',
            accessor: 'isUsed',
            Cell: (cell) => {
                let { original } = cell.cell.row;
                return original.isCompulsory ? 'Yes' : 'No'
            }
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: (cell) => {
                let { original } = cell.cell.row;
                //console.log(cell.cell.row.id)
                return <div style={{ display: 'flex', flexDirection: 'row', border: 'none', alignItems: 'center' }}>
                    <FeatherIcon onClick={() => {
                        setShow(true); setInputData(original);
                    }} style={{ cursor: 'pointer' }} className="icon-dual-info" icon="edit-2" />
                    <FeatherIcon onClick={() => {
                        setShowPop({ show: true }); setInputData(original)
                    }} style={{ marginLeft: '3px', cursor: 'pointer' }} className="icon-dual-danger" icon="trash-2" />
                </div>
            }
        }
    ];

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const fetchRecords = async () => {
        let res = await fetch(`${API}/api/voucher/list`).then(response => response.json());
        if (res.success) {
            setData(res.data);
        }
    }

    const handleSubmit = async () => {
        try {
            let formData = new FormData();
            formData.append("file", inputData[0]);
            let res = await fetch(`${API}/api/uploadexcel`, {
                method: 'POST',
                body: formData
            }).then(response => response.json());
            if (res.success) {
                setNotify({ show: true, variant: 'success', message: 'Saved Successfully!' })
                setInputData({});
                handleClose();
                fetchRecords();
                setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
            } else {
                setNotify({ show: true, variant: 'warning', message: res.error ? res.error.msg : "Something went wrong" })
            }
        } catch (error) {
            console.log(error)
        }
    };

    const onDelete = async (id) => {
        try {
            let res = await fetch(`${API}/api/v1/voucher/${id}`, {
                method: 'DELETE'
            }).then(response => response.json());
            if (res.success) {
                fetchRecords();
                setInputData({});
                setShowPop({ show: false, dataId: '' })
                setNotify({
                    show: true,
                    message: "Deleted Successfully!",
                    variant: "success",
                });
                setTimeout(() => { setNotify({ ...notify, show: false }) }, 3000)
            } else {
                setNotify({
                    show: true,
                    message: `${res.data.error.msg}`,
                    variant: "danger",
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => { fetchRecords(); }, [])
    return (
        <React.Fragment>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Home', path: '/tokenlist' },
                    { label: 'Wifi Tokens/Vouchers', path: '/tokenlist', active: true },
                ]}
                title={'Wifi Tokens/Vouchers'}
            />

            <Popup show={showPop.show}
                handleClose={() => setShowPop({ show: false })}
                handleDelete={() => onDelete(inputData.courseUnitRegisterId)}
            />
            <Alert show={notify.show} variant={notify.variant} >{notify.message}</Alert>
            <Modal show={show} size='lg' centered>
                <Modal.Header onHide={handleClose} closeButton>
                    <p className="text-muted fs-14">
                        Upload Excel file for wifi tokens
                    </p>
                </Modal.Header>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>

                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col lg={12}>
                                            <FileUploader
                                                onFileUpload={(files) => {
                                                    setInputData(files);
                                                }} />
                                            <div className='clearfix text-end mt-3'>
                                                <Button variant="primary" onClick={handleSubmit}>
                                                    Submit
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>

                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal>

            <Row>
                <Col>
                    <Card>
                        <Card.Body>
                            <Row>
                                <Col xs={8}>
                                    <h4 className="header-title">Wifi Tokens/Vouchers</h4>
                                    <p className="text-muted fs-14 mb-4">List of Wifi Tokens/Vouchers</p>
                                </Col>
                                <Col xs={4}>
                                    <Button style={{ float: 'right' }} variant="success"
                                        type="submit" className="btn-sm" onClick={handleShow}>
                                        Add New
                                        <i className='bi-plus-lg' style={{ marginLeft: '5px', fontSize: '' }}></i>
                                    </Button>
                                </Col>
                            </Row>

                            <Table
                                columns={columns}
                                data={data}
                                pageSize={5}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                isSearchable={true}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default WifiToken